import React, { useState } from "react";
import { Form, Input, Button } from "antd";
import { Header } from "../../../../components/Landing/Header/haeder.view";
import { BannerGlobal } from "../../components/Banner";
import "./recuperarcontraseña.style.scss";
import { Footer } from "../../../../components/Landing/Footer";
import { useRecuperarContraseña } from "../../../../hooks/useRecuperarContraseña";
import { RecuperarContraseniaModel, initialValuesRecuperarContraseniaModel } from "../../../../models/UsuariosModel/usuarios.model";
import ModalSuccess from "../../../../utils/Alerts/ModalSuccess";
import ModalError from "../../../../utils/Alerts/ModalWarning";
import ModalWarning from "../../../../utils/Alerts/ModalWarning";

export const RecuperarContraseña = () => {
  const { modalExito, setModalExito, onAceptar, modalFallo, setModalFallo, onFinish } = useRecuperarContraseña();
  const [_data, _setData] = useState<any>({})

  const [usuario, setUsuario] = useState<RecuperarContraseniaModel>(initialValuesRecuperarContraseniaModel);




  const fields = [
    { name: "documento", value: usuario.documento },
    { name: "correo", value: usuario.correo },
  ];

  // onFinish


  const recuperar = async () => {
    const { documento, correo } = usuario;
    const data = await onFinish(documento, correo)
    _setData(data)

  }

  return (
    <div className="d-flex flex-column min-vh-100">
      <Header />
      <BannerGlobal
        Title="Recuperar Contraseña"
        Description="Convocatoria de fomento y estímulos para el arte y la cultura"
      />
      <Form
        layout="vertical"
        name="recuperarcontraseña"
        onFinish={recuperar}
        fields={fields}
        onFieldsChange={(_, fields: any) => {
          let infoupdate: any = { ...usuario };
          for (var i in fields) {
            infoupdate[fields[i].name] = fields[i].value;
          }
          setUsuario(infoupdate);
        }}
      >
        <div className="container-fluid2">
          <div className="row">
            <div className="col-12 mt-4 font-size-18px font-family-Montserrat-Regular">
              Recuperar Contraseña
              <hr />
            </div>

            <div className="col-12 font-size-14px font-family-Montserrat-SemiBold">
              Ingrese sus datos y a continuación utilice el botón "Cambiar contraseña"
            </div>
            <div className="col-12 mt-3">
              <div className="row">
                <div className="col-12 col-md-6 input-padding-right">
                  <Form.Item
                    label={
                      <div className="no-margin">
                        <div className="no-margin letter-spacing-0px font-size-12px font-family-Montserrat">
                          Número de identificación
                        </div>
                      </div>
                    }
                    name="documento"
                    rules={[
                      {
                        required: true,
                        message: "Este campo es requerido",
                      },
                    ]}
                  >
                    <Input size="large" />
                  </Form.Item>
                </div>
                <div className="col-12 col-md-6 input-padding-left">
                  <Form.Item
                    label={
                      <div className="row">
                        <div className="no-margin letter-spacing-0px font-size-12px font-family-Montserrat">
                          Correo electrónico
                        </div>
                      </div>
                    }
                    name="correo"
                    rules={[
                      {
                        type: "email",
                        message: "El correo electrónico es invalido",
                      },
                      {
                        required: true,
                        message: "Porfavor ingresa tu correo electrónico",
                      },
                    ]}
                  >
                    <Input size="large" />
                  </Form.Item>
                </div>
                <div className="col-12 justify-content-flex-end">
                  <Button className="button-azul-radius" htmlType="submit" name="recuperarcontraseña">
                    Cambiar contraseña
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
      <Footer className="footer mt-auto" />
      <ModalSuccess
        visualizar={modalExito}
        setVisualizar={setModalExito}
        onAceptar={onAceptar}
        titlle="Recuperación de contraseña exitoso"
        description="Hemos enviado a su correo electrónico las instrucciones para recuperar su contraseña."
        subdescription="A continuación revise su correo electrónico."
      />
      <ModalWarning
        visualizar={modalFallo}
        setVisualizar={setModalFallo}
        onAceptar={onAceptar}
        description={_data.message}
        subdescription="por favor intentalo de nuevo."
      />
      {/* <ModalExitoso visualizar={modalExito} setVisualizar={setModalExito} onAceptar={onAceptar} /> */}
    </div>
  );
};
